import React, { useEffect } from "react";
import "./index.less";
import mutedMusic from "assets/img/mutedMusic.png";
import playMusic from "assets/img/playMusic.png";
import keywordEntry from "assets/img/keyword-entry.png";
import { collectFunc } from "components";

function Audio({ showKeywordEntry, player, setPlayer, setShowKeyword, showKeyword }) {
  const playerAudio = () => {
    if (player) {
      document.getElementById("player").pause();
      setPlayer && setPlayer(false);
    } else {
      document.getElementById("player").play();
      setPlayer && setPlayer(true);
    }
  };
  const clickKeywordEntry = () => {
    collectFunc({
      eventName: "annualkeyword_entry_click",
      params: { page_name: 'keyword_entry' },
    });
    setShowKeyword(!showKeyword);
  };

  return (
    <div className="audio-button">
      {showKeywordEntry && <div className="keyword-button" onClick={clickKeywordEntry}>
        <img src={keywordEntry} alt="" />
      </div>}
      <div className="audioWrap">
        <audio id="player" loop>
          <source
            src="https://gimg2.gateimg.com/image/1701309079706366847year_report_2023_bgm.mp3"
            type="audio/mp3"
          />
        </audio>
        <div className="playerIcon" onClick={playerAudio}>
          <img alt="" src={player ? playMusic : mutedMusic} />
        </div>
      </div>
    </div>
  );
}

export default Audio;
